<template>
    <div class="editor">
        <div ref="toolbar" class="toolbar"></div>
        <div ref="editor" class="text"></div>
        <el-button @click="upload" type="danger" class="uploadButton">请先保存内容</el-button>
    </div>
</template>

<script>
import E from "wangeditor";
export default {
    name: "Editorbar",
    data() {
        return {
            editor: null,
            info_: null,
            editorData: ""
        };
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        isClear: {
            type: Boolean,
            default: false
        },
        Content: {
            type: String,
            default: ""
        }
    },
    watch: {
        isClear(val) {
            // 触发清除文本域内容
            if (val) {
                this.editor.txt.clear();
                this.info_ = null;
            }
        },
        value(val) {
            // 使用 v-model 时，设置初始值
            this.editor.txt.html(val);
        },
        Content(val) {
            this.editor.txt.html(val);
        }
    },
    mounted() {
        this.seteditor();
    },
    methods: {
        upload() {
            this.editorData = this.editor.txt.html();
            this.$emit("listenTochildEvent", this.editorData);
            this.$message({
                type: "success",
                message: "保存成功"
            });
        },
        changeFather(pms) {},
        seteditor() {
            this.editor = new E(this.$refs.toolbar, this.$refs.editor);
            this.editor.customConfig.uploadImgShowBase64 = true; // base 64 存储图片
            this.editor.customConfig.uploadImgServer =
                this.baseUrl +
                "file/upload_img?token=" +
                this.$store.state.authority_management; // 配置服务器端地址
            this.editor.customConfig.uploadImgHeaders = {}; // 自定义 header
            this.editor.customConfig.uploadFileName = "aaaaaaa"; // 后端接受上传文件的参数名
            this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
            this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
            this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
            // 配置菜单
            this.editor.customConfig.menus = [
                "head", // 标题
                "bold", // 粗体
                "fontSize", // 字号
                "fontName", // 字体
                "italic", // 斜体
                "underline", // 下划线
                "strikeThrough", // 删除线
                "foreColor", // 文字颜色
                "backColor", // 背景颜色
                "link", // 插入链接
                "list", // 列表
                "justify", // 对齐方式
                "quote", // 引用
                "emoticon", // 表情
                "table", // 表格
                "code", // 插入代码
                "undo", // 撤销
                "redo" // 重复
            ];
            this.editor.customConfig.uploadImgHooks = {
                fail: (xhr, editor, result) => {
                    // 插入图片失败回调
                },
                success: (xhr, editor, result) => {
                    // 图片上传成功回调
                },
                timeout: (xhr, editor) => {
                    // 网络超时的回调
                },
                error: (xhr, editor) => {
                    // 图片上传错误的回调
                },
                customInsert: (insertImg, result, editor) => {
                    // 图片上传成功，插入图片的回调
                }
            };
            this.editor.customConfig.onchange = html => {
                this.info_ = html; // 绑定当前逐渐地值
                this.$emit("change", this.info_); // 将内容同步到父组件中
            };
            // 创建富文本编辑器
            this.editor.create();
        }
    }
};
</script>

<style>
.editor {
    width: 650px;
    margin: 0 auto;
}

.toolbar {
    border: 1px solid #ccc;
}

.text {
    border: 1px solid #ccc;
    height: 500px;
}
.uploadButton {
    margin-left: 40%;
    margin-top: 20px;
}
</style>
